import * as z from "zod";
import { UserRole } from "@/pages/auth/types";
import { ShirtSize } from "@/types/shirtSizes";

export const employeeFormSchema = z.object({
  firstName: z.string().min(2, "First name must be at least 2 characters"),
  lastName: z.string().min(2, "Last name must be at least 2 characters"),
  email: z.string().email("Invalid email address"),
  phoneNumber: z.string().min(10, "Phone number must be at least 10 digits"),
  city: z.string().nullable().optional(),
  seniorityLevelId: z.string(),
  eligiblePositionIds: z.array(z.string()),
  taxDocumentsSigned: z.boolean().optional(),
  positionDocuments: z
    .array(
      z.object({
        positionId: z.string(),
        documentSigned: z.boolean(),
      }),
    )
    .optional(),
  role: z.nativeEnum(UserRole),
  emailNotifications: z.boolean(),
  smsNotifications: z.boolean(),
  bilingual: z.boolean().optional(),
  status: z.enum(["PENDING_APPROVAL", "ACTIVE", "INACTIVE", "TERMINATED"]),
  howDidYouHearAboutUs: z.string().optional(),
  shirtSize: z.nativeEnum(ShirtSize, {
    required_error: "Please select a shirt size",
  }),
  receivedShirt: z.boolean().optional(),
  badgeReceived: z.boolean().optional(),
  userNotes: z.string().optional(),
  referredById: z.string().nullable().optional(),
});

export type EmployeeFormValues = z.infer<typeof employeeFormSchema>;
